import { render, staticRenderFns } from "./off-sync-state.vue?vue&type=template&id=5aa075a8&scoped=true"
import script from "./off-sync-state.vue?vue&type=script&lang=js"
export * from "./off-sync-state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa075a8",
  null
  
)

export default component.exports